<template>
    <div>
        <!-- Loan Summary -->
        <b-card no-body class="p-3">
            <b-row>
                <b-col cols="12">
                    <h3>Loan Summary</h3>
                </b-col>
                <b-col cols="12">
                    <b-table-simple borderless class="mortgage-calculator">
                        <b-tbody>
                            <b-tr>
                                <b-td class="title">Monthly Instalment</b-td>
                                <b-td class="value">RM {{ mortgageData.monthly_payment | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Loan Terms</b-td>
                                <b-td class="value">{{ mortgageData.loan_terms }} Years</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Total Payment</b-td>
                                <b-td class="value">RM {{ mortgageData.total_payment | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Total Payable Interest</b-td>
                                <b-td class="value">RM {{ mortgageData.total_interest_payable | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Total Loan Amount</b-td>
                                <b-td class="value">RM {{ mortgageData.total_loan_amount | moneyFormatter }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
            </b-row>
        </b-card>

        <!-- Cash Required -->
        <b-card no-body class="p-3">
            <b-row>
                <b-col cols="12">
                    <h3>Cash Required</h3>
                </b-col>
                <b-col cols="12">
                    <b-table-simple borderless class="mortgage-calculator">
                        <b-tbody>
                            <b-tr>
                                <b-td class="title">Down Payment</b-td>
                                <b-td class="value">RM {{ summaryCashRequired.down_payment | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">SPA Legal Fees</b-td>
                                <b-td class="value">RM {{ summaryCashRequired.spa_legal_fee | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">
                                    Disbursement &amp; Misc Charges
                                    <p class="text-xs text-danger">*You may further<br> seek for your preferred<br> solicitor's estimate charges</p>
                                </b-td>
                                <b-td class="value">RM {{ summaryCashRequired.disbursement_charges | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">SPA Stamp Duty (MOT/DOA)</b-td>
                                <b-td class="value">RM {{ summaryCashRequired.mot_doa | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Loan Legal Fee</b-td>
                                <b-td class="value">RM {{ summaryCashRequired.loan_legal_fee | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Loan Stamp Duty</b-td>
                                <b-td class="value">RM {{ summaryCashRequired.stamp_duty | moneyFormatter }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
            </b-row>
        </b-card>

        <!-- Price/Area -->
        <b-card no-body class="p-3">
            <b-row>
                <b-col cols="12">
                    <h3>Price/Area</h3>
                </b-col>
                <b-col cols="12">
                    <div class="table-simple-modal" style="max-height: 50vh; overflow-y: auto;">
                        <b-table-simple responsive bordered>
                            <b-tbody class="text-center">
                                <b-tr>
                                    <b-td class="font-weight-600">{{ propertyInvestmentRatio.area_sqft }} sqft</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td class="font-weight-600">RM {{ propertyInvestmentRatio.area_sqft_amount | moneyFormatter }} / sqft</b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </div>
                </b-col>
            </b-row>
        </b-card>

        <!-- Property Investment Ratio -->
        <b-card no-body class="p-3">
            <b-row>
                <b-col cols="12">
                    <h3>Property Investment Ratio</h3>
                </b-col>
                <b-col cols="12">
                    <b-table-simple borderless class="mortgage-calculator">
                        <b-tbody>
                            <b-tr>
                                <b-td class="title">Annual Gross Rental Income</b-td>
                                <b-td class="value">RM {{ propertyInvestmentRatio.anual_gross_rental_income | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Annual Maintenance Fee</b-td>
                                <b-td class="value">RM {{ propertyInvestmentRatio.anual_utilities_fees | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Gross Rental Yield</b-td>
                                <b-td class="value">{{ propertyInvestmentRatio.gross_rental_yield | moneyFormatter }}% p.a</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Cash FLow</b-td>
                                <b-td class="value" :class="propertyInvestmentRatio.cash_flow < 0 ? 'text-danger' : 'text-success'">RM {{ propertyInvestmentRatio.cash_flow | moneyFormatter }} / Month</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<script>
export default {
    props: {
        mortgageData: Object,
    },
    data() {
        return {
            tableData: [],
            summaryCashRequired: {},
            propertyInvestmentRatio: {}
        }
    },
    watch: {
        mortgageData: {
        handler(newData) {
                // Update the data properties when mortgageData changes
                this.tableData = newData.amortization_table
                this.summaryCashRequired = newData.summary_cash_required
                this.propertyInvestmentRatio = newData.property_investment_ratio
            },
            immediate: true, // Trigger the handler immediately when the component is created
        },
    },
}
</script>